import styled from 'styled-components';

export const Divider = styled.div`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.designToken.neutral300};
  margin: 10px 0;
`;
